import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'

export const SurveysAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.surveys}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
